const FILENAME_RFC5987 = /filename\*=(?:UTF-8'')?([^;]+)/i;
const FILENAME_QUOTED = /filename="([^"]+)"/i;
const FILENAME_BARE = /filename=([^;]+)/i;

export function parseFilenameFromContentDisposition(headers: Headers): string | null {
  const raw = headers.get('Content-Disposition');
  if (!raw) return null;

  const rfc5987 = raw.match(FILENAME_RFC5987);
  if (rfc5987?.[1]) {
    try {
      return decodeURIComponent(rfc5987[1].trim());
    } catch {
      // fall through to other patterns
    }
  }

  const quoted = raw.match(FILENAME_QUOTED);
  if (quoted?.[1]) return quoted[1];

  const bare = raw.match(FILENAME_BARE);
  if (bare?.[1]) return bare[1].trim();

  return null;
}

export function triggerBrowserDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  // Appending to the DOM before click() is required by older Firefox and some
  // mobile WebViews; modern browsers accept either form. Remove immediately.
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
